import React from 'react';
import { createRoot } from 'react-dom/client';
import './autarch.css';
import './css/_md3-list.css';
import './css/_md3-table.css';
import './css/_md3-actions.css';
import './css/_shared-button.css';
import './css/_brand-colors.css';
import './css/_login.css';
import './css/_form-styles.css';
import './css/_map-styles.css';
import './css/_map-modal.css';
import './css/_similarity-common.css';
import './css/_similarity-step.css';
import './css/_similarity-panel.css';
import './css/_similarity-item.css';
import './css/_similarity-preview.css';
import './css/_similarity-bottom.css';
import './css/_page-viewer.css';
import './app/styles/checkbox.css';
import './app/styles/analytics.css';
import './app/styles/M3Dialog.css';
import './app/styles/analytics-charts.css';
import './app/styles/analytics-conditions.css';
import './app/styles/analytics-dialogs.css';
import './app/styles/analytics-layout.css';
import './app/styles/analytics-map.css';
import './app/styles/analytics-flow.css';
import './app/styles/analytics-workflow.css';
import App from './app/App';

// Mount the full SPA
const container = document.getElementById('react-root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
